import {omit} from 'external/lodash'
import {createElement, ReduxProvider} from 'external/react'
import store from './store'

export default function withStoreProvider(Elem) {
  return (props) => createElement(ReduxProvider, {store}, createElement(Elem, omit(props, ['children']), props.children))
}
